import { collection, doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

const DEFAULT_ROOM_COLLECTION = "games";

function getRoomDocument(roomId, collectionName = DEFAULT_ROOM_COLLECTION) {
  return doc(collection(db, collectionName), roomId);
}

export function setRoomState(
  roomId,
  data,
  collectionName = DEFAULT_ROOM_COLLECTION,
) {
  return setDoc(getRoomDocument(roomId, collectionName), data);
}

export function mergeRoomState(
  roomId,
  data,
  collectionName = DEFAULT_ROOM_COLLECTION,
) {
  return setDoc(getRoomDocument(roomId, collectionName), data, { merge: true });
}

export function subscribeToRoomState(
  roomId,
  onData,
  collectionName = DEFAULT_ROOM_COLLECTION,
) {
  return onSnapshot(getRoomDocument(roomId, collectionName), (snapshot) => {
    onData(snapshot.data(), snapshot);
  });
}
